import React from "react";
import { BarGraphCollection, colors2, Container, PaddingTopBottom20, SkeletonLoader, UI_BODY_SEMIBOLD_SM } from "oolib";
import { MasonryCardGridShell } from "../MasonryCardGridShell";
import { CardAnnoExplorer } from "../CardAnnoExplorer";
import { getAnnoExplorerConfigsForThisTenant } from "../../utils/getAnnoExplorerConfigsForThisTenant";
import { applyTagsWhitelistConfig } from "../../utils/applyTagsWhitelistConfig";
import { ColorCodeDisplay, StyledStatusWrapper, StyledWrapper } from "../ColorCodeDisplay";
import Summary from "../Summary";
import { useGetAnnotations } from "@/utils/react-query-hooks/getData";
import { useAnnotationBarGraphData } from "../../utils/useAnnotationBarGraphData";


export const ListingModuleAnnotationExplorer = ({
  data,
  dataFetchStatus,
  dataFetchError,
  isFetchingNextPage,
  observerRef,
  totalCount,
  breakDown, 
  setBreakDown,
  colorBreakdownStats,
  isMobile,
  activeColorFilter,
  activeFilters,
  selectedTPLsArrayOptions
}) => {
  const annoExplorerConfigs = getAnnoExplorerConfigsForThisTenant()
  const enableBarGraph = !annoExplorerConfigs?.tempDisableBarGraph;
  const {
    data: barGraphData,
    status: barGraphStatus,
    error: barGraphError,
    isLoading: barGraphLoading,
  } = useAnnotationBarGraphData(
    enableBarGraph,
    activeFilters,
    selectedTPLsArrayOptions,
  );

  return (
    <Container
      style={{ background: colors2.grey2, padding: "2rem" }}
    >
        {
          (!data && enableBarGraph || enableBarGraph && barGraphStatus === "loading") 
          ? 
          <SkeletonLoader style={{ width: "100%", height: "250px", borderRadius: "0.8rem", marginBottom: "1rem" }} />
          : 
          (!annoExplorerConfigs?.tempDisableBarGraph) && ( 
            <div style={{ paddingLeft: "40px", background: "white", borderRadius: "0.8rem" }}>
            <BarGraphCollection
                data={barGraphData}
                valuePath="value"
                labelPath="display"
                groupBy="category"
                totalDataCount={totalCount}
                // debug={true}
            />
          </div>
        )
        }

        {dataFetchStatus !== "loading" 
          && 
          <ColorCodeDisplay
            isMobile={isMobile} 
            breakDown={breakDown} 
            setBreakDown={setBreakDown}
            colorBreakdownStats={colorBreakdownStats}
            totalCount={totalCount}
            activeColorFilter={activeColorFilter} 
          />
        } 

      <div>
        { (dataFetchStatus === "loading" && !annoExplorerConfigs?.disableTotalCount) ? 
          <SkeletonLoader style={{ width: "100%", height: "50px", borderRadius: "0.8rem", marginBottom: "1rem" }} /> 
          :
          (data && !annoExplorerConfigs?.disableTotalCount && !breakDown?.activeColorConfig?.tags?.length) && (
          <StyledWrapper isMobile={isMobile}>
            <StyledStatusWrapper>
              <UI_BODY_SEMIBOLD_SM>{`Annotations Showing: ${totalCount || 0}`}</UI_BODY_SEMIBOLD_SM> 
            </StyledStatusWrapper>
          </StyledWrapper>
        )}


        {process.env.VITE_ENV!=="prod" && totalCount?<div style={{margin:".8rem 0"}}>
          <Summary totalCount={totalCount} activeFilters={activeFilters} dataSource={"annotations"} />
        </div>:null}
        

        <MasonryCardGridShell
          dataFetchStatus={dataFetchStatus} //meaning, if the core data has already successfully loaded, then regard the fetchFilteredDataStatus as the dataFetchStatus
          dataFetchError={dataFetchError}
          isFetchingNextPage={isFetchingNextPage}
          data={data}
          renderCard={(cols, colI, singleAnno, singleAnnoI, thisAry, isLastCard) => (
            <CardAnnoExplorer
              cardConfigs={annoExplorerConfigs?.cardConfigs}
              key={singleAnno.annoKey}
              singleAnno={singleAnno}
              lastCardObserverRef={
               isLastCard
                  ? observerRef
                  : null
              }
            />
          )}
        />
      </div>
    </Container>
  );
};
